import { addDays, differenceInDays } from 'date-fns'

export const dataTrackingAdopter = {
  이용권_사용_비율(activeStudents: number, contractValue?: number | null): number | 'unlimited' {
    return !contractValue && contractValue !== 0
      ? 'unlimited'
      : Math.round((activeStudents / contractValue) * 100)
  },
  이용권_잔여_기간(contractEndDate?: Date | null): number | '해지시' {
    return !contractEndDate ? '해지시' : differenceInDays(addDays(contractEndDate, 1), new Date())
  },
}
